// client/src/components/admin/tools/ActionButton.js
// Reusable button component for admin tool actions
import PropTypes from 'prop-types'

/**
 * Simple button component with loading state
 * @param {object} props - Component props
 * @param {string} props.label - Button label text
 * @param {function} props.onClick - Click handler
 * @param {boolean} props.loading - Whether button is in loading state
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {string} props.variant - Bootstrap button variant (primary, danger, etc.)
 * @param {string} props.className - Additional CSS classes
 */
function ActionButton({
  label,
  onClick,
  loading,
  disabled,
  variant = 'primary',
  className = 'btn-tall w-100',
}) {
  return (
    <button
      className={`btn btn-${variant} ${className}`}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading ? 'Working…' : label}
    </button>
  )
}

ActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
}

export default ActionButton
